import React, { useEffect, useState } from "react";
import Collapsible from "react-collapsible";
import { translateText } from "../../../../../../Helper_functions";

const Tabs = (props) => {
  const [FirstRowTabs, setFirstRowTabs] = useState([]);
  const [OtherRowTabs, setOtherRowTabs] = useState([]);
  const [CollapsibleIsOpen, setCollapsibleIsOpen] = useState(false);

  useEffect(() => {
    setFirstRowTabs([...props.Categories].splice(0, 6));
    setOtherRowTabs([...props.Categories].splice(6, props.Categories.length));
  }, []);

  return (
    <div className="tabs-wrapper">
      <section className="tabs-row first-row">
        {FirstRowTabs.length > 0 ? (
          <>
            {FirstRowTabs.map((Tab) => (
              <>
                {Tab.id === "NAV_MENU" ? (
                  <span
                    className={
                      props.SelectedCategory.id === Tab.id &&
                      !props.SearchIsOpen
                        ? "tab-item active"
                        : "tab-item"
                    }
                    onClick={() => props.SelectCategory(Tab)}
                    id="nav-menu-tab"
                  >
                    {Tab.name}
                  </span>
                ) : (
                  <span
                    className={
                      props.SelectedCategory.id === Tab.id &&
                      !props.SearchIsOpen
                        ? "tab-item active"
                        : "tab-item"
                    }
                    onClick={() => props.SelectCategory(Tab)}
                  >
                    {Tab.name}
                  </span>
                )}
              </>
            ))}
          </>
        ) : null}
      </section>
      {OtherRowTabs.length > 0 ? (
        <Collapsible
          onOpening={() => setCollapsibleIsOpen(true)}
          onClosing={() => setCollapsibleIsOpen(false)}
          trigger={
            <section className="trigger-wrapper">
              <span className="sm-hr"></span>
              <button className="trigger">
                {CollapsibleIsOpen ? (
                  <>
                    <i className="feather-minus"></i>
                    {translateText("show_less", props.LangData)}
                  </>
                ) : (
                  <>
                    <i className="feather-plus"></i>
                    {translateText("show_more", props.LangData)}
                  </>
                )}
              </button>
              <span className="sm-hr"></span>
            </section>
          }
        >
          <section className="tabs-row last-row">
            {OtherRowTabs.map((Tab) => (
              <span
                className={
                  props.SelectedCategory.id === Tab.id && !props.SearchIsOpen
                    ? "tab-item active"
                    : "tab-item"
                }
                onClick={() => props.SelectCategory(Tab)}
              >
                {Tab.name}
              </span>
            ))}
          </section>
        </Collapsible>
      ) : null}
    </div>
  );
};

export default Tabs;
